<template>
	<div class="notification-container">
		<NotificationBar
			v-for="notification in notifications"
			:key="notification.id"
			:notification="notification"
		/>
	</div>
</template>

<script>
/** @format */

import NotificationBar from '@/components/NotificationBar.vue';
import {mapState} from 'vuex';

export default {
	components: {
		NotificationBar
	},
	computed: mapState('notification', ['notifications'])
};
</script>

<style scoped>
/** @format */

.notification-container {
	position: fixed;
	bottom: 0;
	right: 0;
	z-index: 10000;
}
</style>
